module.exports = __webpack_public_path__ + "img/36.402f2833.jpg";